import React from "react";
import Slider from "react-slick";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import slider1 from './textfoto.jpg';
import { useNavigate  } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none" }}
        onClick={onClick}
      />
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none" }}
        onClick={onClick}
      />
    );
  }


export default function SimpleSlider() {
  const navigate = useNavigate();

  const { t } = useTranslation();
  
  var settings = {
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    infinite: true,
    speed: 1000,
    fade: true,
    waitForAnimate: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  };
  return (
    <Slider {...settings}>
      <Grid className="masthead slider1" height="100vh" >
      <Box  sx={{ top:'10%',position:'relative'}}>

        <h1 style={{margin:'40px 0 0 0',color:'#fff',textShadow: '2px 2px 5px rgba(0, 0, 0, 0.5)'}}>Navždy.online</h1>
        <h3 style={{margin:'0px 0px 40px 0px',color:'#fff',textShadow: '2px 2px 5px rgba(0, 0, 0, 0.5)'}}>{t('slider1')}</h3>
        <Button className="buttonSlider" variant="outlined" size="large" sx={{color:'#fff',border: '1px solid #fff'}} onClick={() => navigate('info')}>Info</Button>
        </Box>
        </Grid >
        

        {/* <Grid className="masthead slider2" height="100vh" style={{  background: `linear-gradient(to bottom,  rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0)), url("https://www.navzdy.online/assets/img/bg-masthead.jpg");`}}>
      <Box  sx={{ top:'10%',position:'relative'}}>

        <h1 style={{margin:'40px 0 0 0'}}>Navždy.online</h1>
        <h3 style={{margin:'0px 0px 40px 0px'}}>Pomáháme uchovať spomienky na vás i vašich najbližších</h3>
        <Button className="buttonSlider" variant="outlined" size="large" sx={{color:'white',border: '1px solid white'}} onClick={() => navigate('info')}>Info</Button>
        </Box>
        </Grid >

        <Grid className="masthead slider3" height="100vh" >
      <Box  sx={{ top:'10%',position:'relative'}}>

        <h1 style={{margin:'40px 0 0 0'}}>Navždy.online</h1>
        <h3 style={{margin:'0px 0px 40px 0px'}}>Pomáháme uchovať spomienky na vás i vašich najbližších</h3>
        <Button className="buttonSlider" variant="outlined" size="large" sx={{color:'white',border: '1px solid white'}} onClick={() => navigate('info')}>Info</Button>
        </Box>
        </Grid > */}
    </Slider>
  );
}